// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-dialog[data-v-215f81a4]{min-width:150px}.help-dialog__btn-close[data-v-215f81a4]{height:32px;left:10px;position:absolute;top:3px;width:32px}", ""]);
// Exports
module.exports = exports;
